export default {
  statScientistsTitle: "Wissenschaftler & Forscher",
  statScientistsDescription: "Engagierte Fachkräfte, die Innovation in der pharmazeutischen Forschung und Entwicklung vorantreiben",
  statScientistsImage: "https://readdy.ai/api/search-image?query=Professionelle%20pharmazeutische%20Wissenschaftler%20und%20Forscher%20arbeiten%20in%20modernem%20Labor&width=400&height=300",
  statProductsTitle: "Pharmazeutische Produkte",
  statProductsDescription: "Umfassendes Portfolio hochwertiger pharmazeutischer Produkte und APIs",
  statProductsImage: "https://readdy.ai/api/search-image?query=Umfassendes%20Portfolio%20hochwertiger%20pharmazeutischer%20Produkte&width=400&height=300",
  statMarketsTitle: "Globale Märkte",
  statMarketsDescription: "Bedienung der Gesundheitsbedürfnisse in verschiedenen internationalen Märkten mit regulatorischer Exzellenz",
  statMarketsImage: "https://readdy.ai/api/search-image?query=Globale%20pharmazeutische%20M%C3%A4rkte%20und%20internationale%20Gesundheitsversorgung&width=400&height=300",
};

